import services from '@/fetch'
import {getLoginId} from '@/utils/loginId'
import {logo, mainTitle, subTitle, webBackground, supportPic, NODE_ENV} from '@/config'
const app = {
  state: {
    nodeEnv: NODE_ENV,
    apps: [],
    appNo: '',
    appName: '',
    appId: '',
    loginId: '',
    loginSetting: {mainTitle, subTitle, webBackground, logo, supportPic, applicationId: ''},
    isInit: false // 是否初始化
  },
  mutations: {
    SET_APP_IS_INFO: (state, flag) => {
      state.isInit = flag
    },
    SET_APP_NAME: (state, name) => {
      state.appName = name
    },
    SET_APP_ID: (state, id) => {
      state.appId = id
    },
    SET_APP_NO: (state, no) => {
      state.appNo = no
    },
    SET_APPS: (state, apps) => {
      state.apps = apps
    },
    SET_LOGIN_SETTING: (state, setting) => {
      state.loginSetting = { ...state.loginSetting, ...setting }
    }
  },
  actions: {
    GenerateApps ({ commit, state }, data) {
      return new Promise(async (resolve, reject) => {
        try {
          console.log(state.loginSetting)
          const res = await services.getApplication({data: {type: null}})
          const appList = res.appList.map(item => { return {...item, imgUrl: item.imgUrl || 'company.png'} })
          commit('SET_APPS', appList)
          resolve(appList)
        } catch (e) {
          reject(e)
        }
      })
    },
    getLoginSetting ({ commit, state }) {
      return new Promise(async (resolve, reject) => {
        const loginId = getLoginId()
        const res = await services.loginpageOut({method: 'get', suburl: `/${loginId}`})
        res.loginPage.isShowParticles = !res.loginPage.webBackground
        res.loginPage.webBackground = res.loginPage.webBackground || state.loginSetting.webBackground
        res.loginPage.logo = res.loginPage.logo || state.loginSetting.logo
        commit('SET_LOGIN_SETTING', {...res.loginPage, url: res.defaultUrl})
      })
    },
    SetAppInfo ({ commit }, data) {
      commit('SET_APP_ID', data.appId)
      commit('SET_APP_NO', data.applicationNo)
      commit('SET_APP_NAME', data.applicationName)
      commit('SET_APP_IS_INFO', true)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js